var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.66683H1M9.66667 1.3335V4.00016M4.33333 1.3335V4.00016M6 9.3335L7 8.66683V12.0002M6.16667 12.0002H7.83333M4.2 14.6668H9.8C10.9201 14.6668 11.4802 14.6668 11.908 14.4488C12.2843 14.2571 12.5903 13.9511 12.782 13.5748C13 13.147 13 12.5869 13 11.4668V5.86683C13 4.74672 13 4.18667 12.782 3.75885C12.5903 3.38252 12.2843 3.07656 11.908 2.88482C11.4802 2.66683 10.9201 2.66683 9.8 2.66683H4.2C3.0799 2.66683 2.51984 2.66683 2.09202 2.88482C1.71569 3.07656 1.40973 3.38252 1.21799 3.75885C1 4.18667 1 4.74672 1 5.86683V11.4668C1 12.5869 1 13.147 1.21799 13.5748C1.40973 13.9511 1.71569 14.2571 2.09202 14.4488C2.51984 14.6668 3.0799 14.6668 4.2 14.6668Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.eea180694e1044691e35fc3b57bbe1e6.svg";
export { ForwardRef as ReactComponent };